// extracted by mini-css-extract-plugin
export default {"loginBg":"login_loginBg__BiS22","title":"login_title__Fy3qU","icp":"login_icp__KUavB","loginBox":"login_loginBox__mUWy3","logo":"login_logo__fwztG","loginForm":"login_loginForm__0qa17","desc":"login_desc__coc8v","dingdingLogin":"login_dingdingLogin__cAXGi"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"loginBg\":\"login_loginBg__BiS22\",\"title\":\"login_title__Fy3qU\",\"icp\":\"login_icp__KUavB\",\"loginBox\":\"login_loginBox__mUWy3\",\"logo\":\"login_logo__fwztG\",\"loginForm\":\"login_loginForm__0qa17\",\"desc\":\"login_desc__coc8v\",\"dingdingLogin\":\"login_dingdingLogin__cAXGi\"}";
        // 1793842494512
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  